/********************************************************
** MOBILE NAV
********************************************************/
/*
    Open and close functions and click events for the mobile nav menu
*/
function openMobileNav(elem) {
    vHide(elem);
    vShow(elem.nextElementSibling);
    vSlideDown(MOBILEMENU, 500, "block", function() {
        focusFirst(MOBILEMENU);
    });
    // ESC key behavior
    if(!MOBILEMENU.classList.contains("esc-bound")) {
        MOBILEMENU.addEventListener("keyup", function(event) {
            if((event.key === "Escape" || event.keyCode === 27) && MOBILEMENU.style.display !== "none") {
                closeMobileNav(document.querySelector(".js-menu-close"));
            }
        });
        MOBILEMENU.classList.add("esc-bound");
    }
}
function closeMobileNav(elem) {
    vHide(elem);
    vShow(elem.previousElementSibling);
    vSlideUp(MOBILEMENU, 500, function() {
        document.querySelector(".js-menu-open").focus();
    });
}
document.addEventListener("click", function(event) {
    var openMobileNavButton = getParentElementWithClass(event.target, "js-menu-open");
    if(openMobileNavButton !== null) {
        if(document.getElementById("nav-menu-search").style.display == "block" || getComputedStyle(document.getElementById("nav-menu-search")).display == "block" ) {
            closeSearch();
        }
        openMobileNav(openMobileNavButton);
    }
});
document.addEventListener("click", function(event) {
    var closeMobileNavButton = getParentElementWithClass(event.target, "js-menu-close");
    if(closeMobileNavButton !== null) {
        closeMobileNav(closeMobileNavButton);
    }
});


/********************************************************
** SEARCH MENU
********************************************************/
/*
    Open and close functions and click events for the search menu.
*/
function openSearch(elem) {
    elem.classList.add("search-triggering-element");
    let openButtons = document.querySelectorAll(".js-search-open");
    openButtons.forEach(function(button) {
        vHide(button);
        vShow(button.nextElementSibling, "inline-block");
    });
    vSlideDown(SEARCHMENU, 500, "block", function() {
        focusFirst(SEARCHMENU);
    });
    // ESC key behavior
    if(!SEARCHMENU.classList.contains("esc-bound")) {
        SEARCHMENU.addEventListener("keyup", function(event) {
            if((event.key === "Escape" || event.keyCode === 27) && SEARCHMENU.style.display !== "none") {
                closeSearch();
            }
        });
        SEARCHMENU.classList.add("esc-bound");
    }
}
function closeSearch() {
    let closeButtons = document.querySelectorAll(".js-search-close");
    closeButtons.forEach(function(button) {
        vHide(button);
        vShow(button.previousElementSibling, "inline-block");
    });
    vSlideUp(SEARCHMENU, 500, function() {
        var triggeringElement = document.querySelector(".search-triggering-element");
        triggeringElement.classList.remove("js-search-menu-triggered");
        triggeringElement.focus();
    });
}
document.addEventListener("click", function(event) {
    var openSearchButton = getParentElementWithClass(event.target, "js-search-open");
    if(openSearchButton !== null) {
        if(document.getElementById("nav-menu-mobile").style.display == "block" || getComputedStyle(document.getElementById("nav-menu-mobile")).display == "block" ) {
            closeMobileNav(document.querySelector(".js-menu-close"));
        }
        openSearch(openSearchButton);
    }
});
document.addEventListener("click", function(event) {
    var closeSearchButton = getParentElementWithClass(event.target, "js-search-close");
    if(closeSearchButton !== null) {
        closeSearch();
    }
});


/********************************************************
** ALERTS
********************************************************/
/*
    Close function for the alerts banner.
*/
document.addEventListener("click", function(event) {
    if(event.target.classList.contains("js-alert-close")) {
        let alertID = parseInt(event.target.parentElement.getAttribute("data-alertid"));
        if(!isNaN(alertID) && alertID > -1) {
            var expires = new Date();
            expires.setDate(expires.getDate() + 30);
            document.cookie = "pm_alert_dismissed_" + alertID + "=true; expires=" + expires.toUTCString() + ";";
            vHide(event.target.parentElement);
        }
    }
});


/********************************************************
** STICKY NAV
********************************************************/
const stickyObserver = new IntersectionObserver(
    ([e]) => e.target.classList.toggle('sticky', e.intersectionRatio < 1),
    {threshold: [1]}
);
stickyObserver.observe(HEADERS);


/********************************************************
** DROPDOWN MENUS
********************************************************/
/*
    The bevaior of the dropdown menus in the primary desktop nav
*/
// get top-level items from a dropdown menu
var menuItems = document.querySelectorAll('#header-desktop .js-dropdown-root');

// set actions for mouse over and mouse leave
var hoverIntent = new SV.HoverIntent(menuItems, {
	// required parameters
	onEnter: function(targetItem) {
		targetItem.classList.add('active');
        var dropdown = targetItem.getElementsByClassName('js-dropdown-container')[0];
        if(dropdown !== undefined && dropdown !== null) {
            dropdown.setAttribute('aria-expanded', 'true');
            vSlideDown(dropdown);
        }
	},
	onExit: function(targetItem) {
        targetItem.classList.remove('active');
        var dropdown = targetItem.getElementsByClassName('js-dropdown-container')[0];
        if(dropdown !== undefined && dropdown !== null) {
            dropdown.setAttribute('aria-expanded', 'false');
            vSlideUp(dropdown);
        }
	},
	// default options
	exitDelay: 300,
	interval: 100,
	sensitivity: 7,
});
